import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import { titleCase } from 'title-case';
import { Location, Updated } from "./FormattingUtils";
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography'
import CardHeader from '@mui/material/CardHeader';

const getEventIconUrl = (icon, endpoint) => {
    var iconname = titleCase(endpoint) + "_";
    if (icon.impact) {
        if (icon.impact.toLowerCase() === "low") {
            iconname += "low.png"
        } else if (icon.impact.toLowerCase() === "medium") {
            iconname += "medium.png"
        } else if (icon.impact.toLowerCase() === "high" || icon.impact.toLowerCase() === "closed") {
            iconname += "highclosed.png"
        } else {
            iconname += "no.png"
        }
    } else {
        iconname += "no.png"
    }
    iconname = "/mapicons/event/" + iconname;
    return iconname
}

const eventIcon = (icon, endpoint, zoom) => {
    if (zoom >= 11) {
        return {
            url: getEventIconUrl(icon, endpoint),
            anchor: new window.google.maps.Point(17, 17),
            scaledSize: new window.google.maps.Size(35, 29)
        };
    } else if (zoom < 11 && zoom >= 8) {
        return {
            url: getEventIconUrl(icon, endpoint),
            anchor: new window.google.maps.Point(10, 10),
            scaledSize: new window.google.maps.Size(23, 19)
        };
    } else {
        return {
            url: getEventIconUrl(icon, endpoint),
            anchor: new window.google.maps.Point(7, 7),
            scaledSize: new window.google.maps.Size(17, 14)
        };
    }
}

const EventAvatar = React.forwardRef(function MyComponent(props, ref) {
    const d = props.value;
    const module = props.module;
    let imageUrl = getEventIconUrl(d, module.endpoint);
    let imageName = d.impact + " Impact";
    return <Avatar src={imageUrl} alt={imageName} {...props} ref={ref} variant="square" sx={{ height: '30px', width: '36px', objectFit: "contain" }} title={module.label + d.displayId} />
});

const EventInfoWindow = (props) => {
    const module = props.module;
    const obj = props.icon;
    const MyCardContent = module.cardContent;
    const showCardContent = module.showCardContent;

    return (
        <Box className="infoWindow" sx={{m:0,p:0}}>
            <EventInfoHeader obj={obj} module={module} />
            {showCardContent(obj) ?
                <Box className="spacer"><MyCardContent obj={obj} /></Box>
                :
                null}
            <hr>
            </hr><Updated icon={obj} />
        </Box>
    )
}

const EventInfoHeader = (props) => {
    const obj = props.obj;
    const module = props.module;
    return (
        <CardHeader
            sx={{ m: 0, p: 0  }}
            avatar={
                <EventAvatar value={obj} module={module} />
            }
            title={<Box sx={{color:"rgba(0,0,0,0.7)"}}>{obj.type}</Box>}
            subheader={<Box sx={{color:"rgba(0,0,0,0.7)"}}><Location obj={obj} /></Box>
            }
        />
    )
}

const showCardContent = (obj) => { return (obj.advisoryText && obj.advisoryText !== "") }

const EventCardContent = (props) => {
    const obj = props.obj;
    return (
        <Box>
            <Box sx={{ mt: 1 }}>
                <Typography variant="body2">{obj.advisoryText}</Typography>
            </Box>
            {obj.detourText !== "" &&
                <Box sx={{ mt: 1 }}>
                    <Typography variant="subtitle2">Detour</Typography>
                    <Typography variant="body2">{obj.detourText}</Typography>
                </Box>

            }
        </Box >
    )
}

const EventCardTitle = (props) => {
    const obj = props.obj;
    return (
        <Location obj={obj} />
    )
}


export {
    EventCardTitle,
    showCardContent,
    EventCardContent,
    eventIcon,
    EventAvatar,
    EventInfoWindow
}
